import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  Box,
  ButtonStyled,
  DurationOption,
  DurationToggle,
  DurationToggleContainer,
  HeadingStyled,
  SpanStyled,
  SubHeadingStyled,
  TextStyled,
  ToggleButton,
} from "../../Styled/Elements";
import { PricingWrapper, PricingCardWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import { durationOptions, pricingPlans } from "../../data/Data";
import { ButtonCustom, CheckList } from "../../Styled/CustomElements";
import {
  Chat,
  ChatPopup,
  Check,
  ChevronLeft,
  ChevronRight,
  DollarIcon,
} from "../../Styled/AllImages";
import CustomModal from "./components/CustomModal";
import { toast } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

const customPlan = {
  id: 0,
  plan_name: "custom_enterprise_plan",
  desc: "custom_solutions_for_comprehensive_doc_management",
  price: 0,
  btn_text: "contact_sales_team",
  color: "var(--themeColor2)",
  stroke: "var(--themeColor2)",
  bg: "--white",
  border: "#eaedf3",
  isBorder: false,
  isCustom: true,
  isBasic: false,
  access_features: [
    "unlimited_archives",
    "tailored_features_integration",
    "dedicated_account_manager",
    "contact_sales_team_for_customized",
  ],
};

// export const enterprisePlanCheckList = [
//   {
//     id: 1,
//     listTxt: "UnlimitedArchives",
//   },
//   {
//     id: 2,
//     listTxt: "TailoredFeaturesandIntegrations",
//   },
//   {
//     id: 3,
//     listTxt: "DedicatedAccountManager",
//   },
//   {
//     id: 4,
//     listTxt: "ContactSalesTeamCustomizedSolution",
//   },
// ];

export const enterprisePlanCheckList = [
  {
    id: 1,
    listTxt: "centralized_secure_organization",
  },
  {
    id: 2,
    listTxt: "permissions_access_control",
  },
  {
    id: 3,
    listTxt: "flexible_structure_business_nature",
  },
  {
    id: 4,
    listTxt: "tailored_experience_entity_needs",
  },
];

const Pricing = () => {
  const WEBSITE_URL = process.env.REACT_APP_WEBSITE_BASE_URL;
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [show, setShow] = useState(false);
  const [pricingPlans, setPricingPlans] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState(1);

  const handleShow = () => setShow(true);
  const contactSales = () => {
    setShow(true); // Show the modal
  };
  const handlePlanClick = (plan) => {
    console.log(plan);

    window.open(
      `${WEBSITE_URL}/signup?plan_id=${plan.id}&duration=${
        plan?.duration || 1
      }`,
      "_blank"
    );
  };

  const getPlansList = async () => {
    const url = `${API_URL}/get-plans`;
    try {
      const response = await fetch(url, {
        headers: {
          "X-localization": language,
        },
      });
      const data = await response.json();

      if (response?.ok) {
        const plans = data?.data
          ?.filter(
            (plan) =>
              plan.plan_prices.some(
                (priceObj) => priceObj.duration === selectedDuration
              ) || plan?.category === "free"
          )
          ?.map((plan) => {
            const selectedPriceObj = plan.plan_prices.find(
              (p) => p.duration === selectedDuration
            );
            const price = selectedPriceObj
              ? parseFloat(selectedPriceObj.price)
              : 0;

            let rawFeatures = [];
            if (selectedDuration === 1) {
              rawFeatures =
                language === "en"
                  ? plan.monthly_features_en
                    ? JSON.parse(plan.monthly_features_en)
                    : []
                  : plan.monthly_features_ar
                  ? JSON.parse(plan.monthly_features_ar)
                  : [];
            } else if (selectedDuration === 12) {
              rawFeatures =
                language === "en"
                  ? plan.annual_features_en
                    ? JSON.parse(plan.annual_features_en)
                    : []
                  : plan.annual_features_ar
                  ? JSON.parse(plan.annual_features_ar)
                  : [];
            }

            return {
              id: plan.id,
              plan_name: plan.title,
              desc: plan.description,
              duration: selectedPriceObj?.duration,
              plan_prices: plan?.plan_prices,
              price,
              category: plan.category,
              btn_text: "get_started",
              color:
                plan.category === "free"
                  ? "var(--themeColor2)"
                  : "var(--white)",
              stroke:
                plan.category === "free"
                  ? "var(--themeColor2)"
                  : "var(--themeColor)",
              bg: plan.category === "free" ? "--white" : "--themeColor",
              border:
                plan.category === "free"
                  ? "var(--themeColor2)"
                  : "var(--themeColor)",
              isBorder: true,
              isCustom: false,
              isBasic: price === 0,
              access_features: rawFeatures.map((item) => item.trim()),
              // access_features:
              //   language === "en"
              //     ? plan?.features_en
              //       ? JSON.parse(plan.features_en)?.map((item) => item.trim())
              //       : []
              //     : plan?.features_ar
              //     ? JSON.parse(plan.features_ar)?.map((item) => item.trim())
              //     : [],
            };
          });

        // Add static custom plan as the last plan
        setPricingPlans([...plans]);

        console.log(pricingPlans);
      } else {
        toast.error(t("failed_to_fetch_plans"));
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    getPlansList();
  }, [language, selectedDuration]);

  return (
    <PricingWrapper id="pricing" lang={language} className="pt-5">
      <Container className="px-5 px-md-2">
        <Box className="text-center">
          <HeadingStyled
            size="36px"
            color="var(--text)"
            className="main-heading responsive-heading"
          >
            {t("flexible_plan_for_every_business")}
          </HeadingStyled>
          <TextStyled
            color="var(--text)"
            weight="400"
            size="16px"
            className="mb-6 justify-content-center"
          >
            {t("flexible_plans_to_suit_business")}
          </TextStyled>
        </Box>
        <Box>
          {/* <DurationSelect
            value={selectedDuration}
            onChange={(e) => setSelectedDuration(Number(e.target.value))}
          >
            {durationOptions.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {t(opt.label)}
              </option>
            ))}
          </DurationSelect> */}
          {/* <DurationToggleContainer>
            <DurationToggle>
              <DurationOption
                active={selectedDuration === 1}
                onClick={() => setSelectedDuration(1)}
              >
                {t("monthly")}
              </DurationOption>
              <DurationOption
                active={selectedDuration === 12}
                onClick={() => setSelectedDuration(12)}
              >
                {t("annually")}
              </DurationOption>
            </DurationToggle>
          </DurationToggleContainer> */}
        </Box>
        <Box className="mt-4 position-relative">
          {/* <Row> */}
          <Swiper
            key={language}
            dir={language === "ar" ? "rtl" : "ltr"}
            rtl={language === "ar"}
            modules={[Pagination, Navigation]}
            loop={true}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            spaceBetween={30}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
            }}
          >
            {pricingPlans.map((plan, key) => (
              <SwiperSlide key={key}>
                <PricingCardWrapper
                  className={`p-4 p-md-3 custom-p-lg-4 my-2`}
                  color={plan.stroke}
                  border={plan.border}
                  isBorder={plan.isBorder}
                >
                  <SubHeadingStyled
                    weight="bold"
                    size="24px"
                    color="var(--text)"
                    className="plan-heading"
                  >
                    {t(plan.plan_name)}
                  </SubHeadingStyled>
                  <TextStyled
                    size="16px"
                    weight="400"
                    color="var(--text2)"
                    className="plan-desc"
                  >
                    {t(plan.desc)}
                  </TextStyled>
                  {plan.isCustom ? (
                    <>
                      <Box className="mb-3 pt-2">
                        <Box className="pb-2">
                          <ChatPopup />
                        </Box>
                        <TextStyled color="var(--text)" size="14px">
                          {t("contact_sales_for_pricing")}
                        </TextStyled>
                      </Box>
                    </>
                  ) : (
                    <Box className="mt-3 mb-3">
                      <SubHeadingStyled
                        size="28px"
                        weight="bold"
                        color={plan.stroke}
                      >
                        {plan?.category === "free" ? (
                          t("free")
                        ) : (
                          <Box className="d-flex align-items-center">
                            <DollarIcon />
                            <SpanStyled className="mt-2">
                              {plan.price}
                            </SpanStyled>
                          </Box>
                        )}
                      </SubHeadingStyled>
                      <TextStyled color="var(--text)" size="14px">
                        {plan.isCustom
                          ? t("contact_sales_for_pricing")
                          : plan?.category === "free"
                          ? plan?.plan_prices[0]?.duration == 0
                            ? t("free_forever")
                            : `${plan?.plan_prices[0]?.duration} ${t("months")}`
                          : plan?.duration == 1
                          ? t("monthly")
                          : plan?.duration == 12
                          ? t("annually")
                          : "N/A"}
                        {/* {plan.isBasic
                          ? t("free_forever")
                          : plan.isCustom
                          ? t("contact_sales_for_pricing")
                          : t("per_user_month")} */}
                      </TextStyled>
                    </Box>
                  )}
                  <ButtonCustom
                    label={t(plan.btn_text)}
                    bg={`var(${plan.bg})`}
                    border={plan.color}
                    color={plan.color}
                    className="w-100 justify-content-center"
                    clName="w-100"
                    onClick={() => handlePlanClick(plan)}
                    // {...(plan.isCustom
                    //   ? { onClick: handleShow }
                    //   : { onClick: () => handlePlanClick(plan) })}
                  />
                  <Box className="mt-4">
                    {plan.access_features.map((ftr, i) => (
                      <Box className="d-flex mb-2">
                        <Box>
                          <Check />
                        </Box>
                        <TextStyled
                          size="16px"
                          color="var(--text)"
                          className="mx-2"
                        >
                          {t(ftr)} 
                        </TextStyled>
                      </Box>
                    ))}
                  </Box>
                </PricingCardWrapper>
              </SwiperSlide>
            ))}
            <SwiperSlide>
              <PricingCardWrapper
                className={`p-4 p-md-3 custom-p-lg-4 my-2`}
                // color={plan.stroke}
                border={"var(--themeColor2)"}
                isBorder={true}
              >
                <Box className="headToTxt">
                  <SubHeadingStyled color="var(--text)" size="24px">
                    {/*{t("EnterprisePlanCustom")}*/}
                    {t("solutions_designed_for_your_entity")}
                  </SubHeadingStyled>
                  {/* <Box className="descBox">
                    <TextStyled size="15px" color="var(--text2)">
                      {t("CustomSolutionsComprehensive")}
                    </TextStyled>
                  </Box> */}
                  {/*<Box className="descBox">
                    <TextStyled size="15px" color="var(--text2)">
                      {t("solutions_designed_for_your_entity")}
                    </TextStyled>
                  </Box>*/}
                  <Box className="subsContactIcon">
                    <Chat />
                  </Box>
                  <TextStyled size="14px" color="var(--text)">
                    {t("enterprise_plan_description_body")}
                  </TextStyled>
                </Box>
                <Box className="commonBtns w-100 p-0 mt-3">
                  <ButtonCustom
                    bg="transparent"
                    border="var(--themeColor2)"
                    color="var(--themeColor2)"
                    size="20px"
                    padding="12px 20px"
                    weight="bold"
                    clName="w-100"
                    className="w-100 justify-content-center"
                    label={t("request_demo_cta")}
                    onClick={contactSales}
                  ></ButtonCustom>
                </Box>
                <CheckList
                  listData={enterprisePlanCheckList}
                  listBlue={false}
                />
              </PricingCardWrapper>
            </SwiperSlide>
          </Swiper>

          <Box className="swiper-button-prev custom-nav">
            <ChevronLeft />
          </Box>
          <Box className="swiper-button-next custom-nav">
            <ChevronRight />
          </Box>
          {/* </Row> */}
        </Box>
      </Container>
      <CustomModal
        show={show}
        setShow={setShow}
        title={t("contact_our_sales_team")}
      />
    </PricingWrapper>
  );
};

export default Pricing;
